<template>
  <div class="page-column">
      <div class="header">
          <div class="status" >
              <div class="status-cell" v-for="(status,index) in statusList" :key="index" :class="activeStatus == index? 'activeBg':'inactiveBg' " @click="statusSwitch(index,status.code)">{{status.name}}</div>
          </div>
          <div class="search">
            <input class="search-input" type="text" placeholder="请输入赛事名称搜索" v-model="searchVal">
            <img class="search-icon" src="../../../assets/search_icon.png" alt="" @click="search()">
          </div>
          <div class="total">
            已举办赛事：{{totalNum}}场
            <!-- &nbsp;系列赛：{{series}}场&nbsp;独立赛：{{dependent}}场&nbsp;运动会：{{sportsMeeting}}场 -->
          </div>
      </div>
      <div class="body">
          <div class="matchCell" v-for="(match,index) in matchList" :key="index" @click="matchClick(match.id)">
            <div class="logo">
              <img class="logo-img" :src="match.logo" alt="">
            </div>
            <div class="other">
              <div class="name">{{match.title}}</div>
              <div class="info">
                <div class="time">比赛时间：{{match.beginTime.slice(0,10)}}</div>
                <div class="rate">赛事级别：{{match.levelName}}</div>
                <div class="address">比赛地点：{{match.address}}</div>
              </div>
              <div class="ope-btn" :style="{backgroundColor:getOperation(match.status).bgColor}" >{{getOperation(match.status).name}}</div>
            </div>
          </div>
      </div>
      <div class="pages" v-if="matchList.length !==0">
        <a-pagination v-model="current" :total="totalNum" :defaultPageSize="params.pageSize" show-less-items @change="onChange"/>
      </div>
  </div>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      params: {
        programId: this.$route.query.programId,
        pageNum: 1,
        pageSize: 20,
        keyWord: -1,
        status: -1
      },
      statusList: [
        {code: -1, name: '全部'},
        {code: 1, name: '计划中', bgColor: '#b99523'},
        {code: 2, name: '报名中', bgColor: '#F73C13'},
        {code: 3, name: '进行中', bgColor: '#008000'},
        {code: 4, name: '已结束', bgColor: '#BBB'}
      ],
      searchVal: null,
      totalNum: 569,
      series: 21,
      dependent: 537,
      sportsMeeting: 10,
      activeStatus: 0,
      current: 1,
      matchList: []
    }
  },
  created () {
    window.scrollTo(0, 0)
    this.loadData()
  },
  methods: {
    matchClick (id) {
      store.commit('match/MATCH_CHANGE_ACTIVE_MENU', 1)
      this.$router.push({name: 'MatchDetail', query: {matchId: id, programId: this.params.programId}})
    },
    search () {
      if (this.searchVal !== '' && this.searchVal !== undefined && this.searchVal !== null) {
        this.params.keyWord = this.searchVal
        console.log('sss', this.params.keyWord)
        this.loadData()
      }
    },
    getOperation (status) {
      let result = {}
      this.statusList.forEach(data => {
        if (data.code == status) {
          result = data
        }
      })
      return result
    },
    onChange (page, pageSize) {
      // console.log(page, pageSize)
      this.params.pageNum = page
      this.loadData()
    },
    statusSwitch (index, code) {
      this.activeStatus = index
      this.params.status = code
      this.loadData()
    },
    loadData () {
      this.$api.match.programPageMatchList(this.params).then(res => {
        // console.log('programPageMatchList', res)
        if (res.status == 0) {
          this.matchList = res.data
          this.totalNum = res.total
          // 将搜索关键词清空
          this.params.keyWord = -1
          this.searchVal = ''
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin: 70px auto;
  // background-color: green;
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.status{
  flex: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  // background-color: red;
}
.status-cell{
  // width: 18%;
  flex: 1;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  font-size: 13px;
  font-weight: normal;
  padding: 5px 0;
}
.inactiveBg{
  background-color: #BFBFBF;
}
.activeBg{
  background-color: #B01F24;
}
.search{
  flex: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  // background-color: green;
}
.total{
  flex: 3;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 13px;
}
.search-input{
  width: 271px;
  padding-left: 50px;
  border: 0px;
  outline: none;
  border-bottom: 1px solid #b3b3b3;
  font-size: 13px;
}
.search-icon{
  width: 17px;
  height: 17px;
}
.body{
  width: 100%;
  padding: 10px calc(50% - 600px);
  background-color: #EEE;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.pages{
  width: 100%;
  padding: 10px calc(50% - 600px);
  background-color: #EEE;
  display: flex;
  justify-content: center;
}
.matchCell{
  width: 48%;
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 15px;
  background: #FFF;
  // background: red;
}
.logo{
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // background: green;
}
.logo-img{
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.other{
  // background: yellow;
  flex: 4;
  // width: 450px;
  // background: green;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.name{
  height: 22px;
  line-height: 22px;
  // background-color: yellow;
  font-size: 17px;
  font-weight: bold;
  color: #000;
}
.info{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 20px;
  line-height: 20px;
  // background: red;
  font-size: 13px;
  font-weight: normal;
  color: #999;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ope-btn{
  width: 100px;
  text-align: center;
  font-size: 13px;
  color: #FFF;
  height: 27px;
  line-height: 27px;
  // background: #B01F24;
  border-radius: 4px;
  margin-top: 12px;
}
.time{
  margin-right: 15px;
}
.rate{
  margin-right: 15px;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/matchCell/MatchCell.vue